'use strict';

module.exports = require('./lib/React');



//////////////////
// WEBPACK FOOTER
// ./~/._react@15.5.4@react/react.js
// module id = 7
// module chunks = 0